export { TERMS_VERSION, TERMS_HTML } from "./terms-v2025-12-01";
export { PRIVACY_VERSION, PRIVACY_HTML } from "./privacy-v2025-12-01";

export const LEGAL_TERMS_VERSION = "2025-12-01";
export const LEGAL_PRIVACY_VERSION = "2025-12-01";
